import { isItUndefined, modifyLinks } from '../../util/DataUtil';
import React, { useState } from 'react';
import Link from 'next/link';
import { useRouter } from 'next/router';

const FacilityRegionList = (data) => {
  // let locations = data.children.field_region.region_list_paragraph;
  let metros = data.locationsData.metros;
  const [locations, setLocations] = useState(
    data?.children?.field_region?.region_list_paragraph
  );
  const { locale } = useRouter();

  if (!locations || !metros) {
    return <></>;
  }

  const getKeyForObject = (string, obj) => {
    if (!string) {
      return;
    }

    let matches = string.match(/\[(.*?)]/);

    if (matches) {
      let submatch = matches[1].slice(1);

      return string.replace('[[' + submatch + ']]', keyExists(obj, submatch));
    } else {
      return string;
    }
  };

  const keyExists = (obj, key) => {
    if (!obj || (typeof obj !== 'object' && !Array.isArray(obj))) {
      return false;
    } else if (obj.hasOwnProperty(key)) {
      return obj[key][0].value !== undefined ? obj[key][0].value : obj[key];
    } else if (Array.isArray(obj)) {
      for (let i = 0; i < obj.length; i++) {
        const result = keyExists(obj[i], key);
        if (result) {
          return result;
        }
      }
    } else {
      for (const k in obj) {
        const result = keyExists(obj[k], key);
        if (result) {
          return result;
        }
      }
    }
    return false;
  };

  const renderLocations = () => {
    return locations.map((item, key) => {
      // const dataSet = {...data?.metroData.regions[key]};
      const dataSet = { ...data?.metroData };

      return (
        <div key={`location-${item?.field_region_title?.[0]?.value || key}`} className={'location'}>
          <div className={'regions-header'}>
            <div className={'title'}>
              {isItUndefined(item?.field_region_title)}
            </div>
            <div className={'chip'}>
              <p>
                {chipCounter(
                  item?.field_region_list_region_name
                    ? item?.field_region_list_region_name[0]
                        ?.original_tranlsation
                    : undefined,
                  metros,
                  item?.field_regions
                )}{' '}
                {item?.field_region_chip_text[0]?.value}
              </p>
            </div>
          </div>
          <div className={'regions-bottom'}>
            <div className={'left'}>
              <div
                className={'description'}
                dangerouslySetInnerHTML={{
                  __html: modifyLinks(
                    getKeyForObject(
                      item?.field_region_description[0]?.value,
                      dataSet
                    ),
                    locale
                  ),
                }}
              />
              <div className={'link'}>
                <Link href={isItUndefined(item?.field_region_link)} passHref>
                  <a className={'a-region-list-link'}>
                    {isItUndefined(item?.field_region_link_text)}
                  </a>
                </Link>
                {isItUndefined(item?.field_region_link_text) && (
                  <img
                    width={'auto'}
                    height={'auto'}
                    className={'more-arrow'}
                    src={'/images/arrow-right-white.svg'}
                    alt={'arrow'}
                  />
                )}
              </div>
            </div>
            <div className={'regions-container'}>
              {renderRegions(
                item?.field_region_list_region_name
                  ? item?.field_region_list_region_name[0]?.original_tranlsation
                  : undefined,
                metros,
                item?.field_regions
              )}
            </div>
          </div>
          <hr />
        </div>
      );
    });
  };

  const chipCounter = (region, metros, regions) => {
    let results = [];

    if (region !== undefined) {
      for (let item of metros) {
        if (region === item?.region) {
          results.push(item?.field_metro_name);
        }
      }
    } else {
      for (let item of regions) {
        results.push(item?.value);
      }
    }

    return results.length;
  };

  const renderRegions = (region, metros, regions, lang) => {
    if (region !== undefined) {
      const sortedMetros = [...metros].sort((a, b) =>
        a?.field_metro_name[0]?.name.localeCompare(
          b?.field_metro_name[0]?.name,
          lang
        )
      );

      return sortedMetros
        .filter((item) => item?.region === region)
        .map((item, key) => (
          <Link key={`region-link-${item?.field_metro_name?.[0]?.name || key}`} href={item['url-alias']} passHref>
            <a key={`region-a-${item?.field_metro_name?.[0]?.name || key}`} className="region">
              {item?.field_metro_name[0]?.name}
            </a>
          </Link>
        ));
    } else {
      const sortedRegions = [...regions].sort((a, b) =>
        a?.value.localeCompare(b?.value, lang)
      );

      return sortedRegions.map((item, key) => (
        <div key={`region-${item?.value || key}`} className="region">
          {item?.value}
        </div>
      ));
    }
  };

  return (
    <div id={'regions'} className="dark">
      <div className={'inner-container'}>{renderLocations()}</div>
    </div>
  );
};

export default FacilityRegionList;
